import { useMemo } from "react";

import { defineMessage, useIntl } from "react-intl";

import { ProductKeyTypes } from "@/libraries/wpl/foundations/src";

import { MobileNavCardProps } from "./mobile-nav-card";
import { MobileNavMenuPage } from "./mobile-nav-menu-page";

export const MobileNavProductBusinessTeams = ({
    productKey = "home"
}: {
    productKey?: ProductKeyTypes;
}) => {
    const intl = useIntl();

    function useProductsData(): Array<MobileNavCardProps> {
        return useMemo(() => {
            return [
                {
                    key: "jira",
                    logo: "jira",
                    href: "/software/jira",
                    name: "Jira",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.jira.description",
                            defaultMessage: "Flexible project management"
                        })
                    ),
                    isNew: false
                },
                {
                    key: "confluence",
                    logo: "confluence",
                    href: "/software/confluence",
                    name: "Confluence",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.confluence.description",
                            defaultMessage: "Knowledge, all in one place"
                        })
                    ),
                    isNew: false
                },
                {
                    key: "trello",
                    logo: "trello",
                    href: "//trello.com/home",
                    name: "Trello",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.trello.description",
                            defaultMessage: "Organized & visualized work"
                        })
                    ),
                    isNew: false
                },
                {
                    key: "loom",
                    logo: "loom",
                    href: "//loom.com",
                    name: "Loom",
                    description: intl.formatMessage(
                        defineMessage({
                            id: "globalnav.v2.products.loom.description",
                            defaultMessage: "Quick, async video updates"
                        })
                    ),
                    isNew: true
                }
            ];
        }, []);
    }

    const productsData = useProductsData();

    return (
        <MobileNavMenuPage
            pageLabel={intl.formatMessage({
                id: "globalnav.v2.productsbusinessteams.title",
                defaultMessage: "Products for Business Teams"
            })}
            cards={productsData}
            productKey={productKey}
        />
    );
};
